import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String }

  track() {
    fetch(this.urlValue, {
      method: 'POST',
      keepalive: true,
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content }
    })
  }
}
